import { useMemo } from "react";
import { AccountingLedgerBasis } from "@common/types/domains/accounting/ledger";
import { useProfitAndLossQuery } from "@api/accountingReports.api";
import {
    CashLedgerReportParams,
    useCashLedgerReportFilters,
} from "../shared/useCashLedgerReportFilters";
import { buildSpreadsheetRows } from "./profitLossActivationUtils";

interface UseProfitLossReportParams extends CashLedgerReportParams {
    includeCounterpartyBreakdown: boolean;
}

export const useProfitLossReport = ({
    includeCounterpartyBreakdown,
    ...params
}: UseProfitLossReportParams) => {
    const {
        ledgerId,
        ledgersQuery,
        filters: cashLedgerFilters,
    } = useCashLedgerReportFilters(params);

    const filters = useMemo(
        () => ({
            ...cashLedgerFilters,
            ledgerBasis: AccountingLedgerBasis.cash,
        }),
        [cashLedgerFilters],
    );

    const { profitAndLoss } = useProfitAndLossQuery(filters, {
        enabled: true,
        includeCounterpartyBreakdown,
    });

    const rows = useMemo(
        () =>
            profitAndLoss.data
                ? buildSpreadsheetRows(profitAndLoss.data)
                : null,
        [profitAndLoss.data],
    );

    return { profitAndLoss, rows, ledgerId, ledgersQuery, filters };
};
